var render, staticRenderFns
import script from "./standard_protect.vue?vue&type=script&lang=js"
export * from "./standard_protect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cf460d0')) {
      api.createRecord('9cf460d0', component.options)
    } else {
      api.reload('9cf460d0', component.options)
    }
    
  }
}
component.options.__file = "found/views/tpm/views/fee_regular/standard_protect/standard_protect.vue"
export default component.exports